import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_NUMBER_FORMAT_BASE_PATH = '/CaseNumberFormat';

export const caseNumberFormatEndpoints = {
  list: () => buildEndpoint(CASE_NUMBER_FORMAT_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${CASE_NUMBER_FORMAT_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${CASE_NUMBER_FORMAT_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(CASE_NUMBER_FORMAT_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${CASE_NUMBER_FORMAT_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${CASE_NUMBER_FORMAT_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${CASE_NUMBER_FORMAT_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default caseNumberFormatEndpoints;
